import type { AchievementI18N } from '../../../services/generated/Api';
import { clampLanguage, useLanguage, useLanguageStore, type Language } from '../../../stores/languageStore';

export type Lang = Language;

export const pickLang = (): Lang => clampLanguage(useLanguageStore.getState().language);

export const useAchievementLang = (): Lang => clampLanguage(useLanguage());

export function pickTitle(i18n: AchievementI18N | undefined, lang: string = pickLang()): string {
  if (!i18n) return '';
  return i18n[clampLanguage(lang)].title;
}

export function pickDescription(i18n: AchievementI18N | undefined, lang: string = pickLang()): string {
  if (!i18n) return '';
  return i18n[clampLanguage(lang)].description;
}
